// extracted by mini-css-extract-plugin
export default {"container":"ok-z","heading":"pk-z","items":"qk-z","action":"rk-z","disabled":"sk-z"};